import con from '../../../connection';
var path = '/islogin';
var islogin = function (url) { return function () { return ({
    get: function () {
        return con.get(url + path, {}, true);
    },
}); }; };
export default islogin;
